<template>
  <el-tabs type="card" class="group-tabs" @tab-click="activeTag">
    <el-tab-pane v-for='(item,index) in reports' :key="item.id" :label="item.name">
        <div slot="label"
            :title="item.name.length>9?item.name:''"
            class="tags-view-item"
            >
            <span class="name">{{item.name.length>9?item.name.slice(0,8)+'...':item.name}}</span>
            </div>
          <report-component ref="reportTab" v-if="item.report" :report='item.report' :formRuntimeDialog="formRuntimeDialog" @closeReportDialog="closeReportDialog" :formDefinition="formDefinition"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

export default {
  name: 'group-report-tabs',
  props: ['groupReports', 'formRuntimeDialog'],
  components: {
    ReportComponent: () => import('./report-component.vue')
  },
  data () {
    return {
      reports: [],
      powersListIds: [],
      design: false,
      formDefinition: {}
    }
  },
  created () {
    if (this.$route.path.includes('report-design-list')) {
      this.design = true
      this.loadReports()
    } else {
      this.design = false
      this.getRole().then(() => {
        this.loadReports()
      })
    }
  },

  methods: {
    recursive (list, result = []) {
      list.forEach(it => {
        result.push(it.id)
        it.children && it.children.length && this.recursive(it.children, result)
      })
      return result
    },
    getRole () {
      return this.$axios.get('/auth-api/menus/menusByUser').then(res => {
        this.powersListIds = this.recursive(res.data)
      })
    },
    async loadReport (reportId) {
      // 加载报表信息
      return (await this.$axios.get(`/report-api/report/definition/${reportId}?type=run`)).data
    },
    loadReports () {
      let allGroupReports = []
      // 遍历所有组合报表, 加载报表定义信息
      if (this.design) {
        allGroupReports = this.groupReports
      } else {
        allGroupReports = this.groupReports.filter(m => this.powersListIds.includes(m.id))
      }
      allGroupReports.forEach(item => {
        this.reports.push({
          ...item,
          report: null
        })
      })
      if (this.reports.length) {
        this.activeTag({label: this.reports[0].name})
      } else {
        this.$message.error('菜单引用的报表没权限')
      }
    },
    async activeTag (_tab, index) {
      const tab = this.reports.find((item) => item.name === _tab.label)
      this.reports.forEach(m => {
        m.report = null
      })
      let report = await this.loadReport(tab.id)
      report.mergeSame = report.mergeSame ? JSON.parse(report.mergeSame) : []
      report.clickColumn = typeof (report.clickColumn) === 'string' ? JSON.parse(report.clickColumn) : report.clickColumn
      report.maxTotal = Number(report.maxTotal)
      report.filters && report.filters.forEach(n => {
        n.dataSource = JSON.parse(n.dataSource)
        n.template = JSON.parse(n.template)
      })
      // 关联的子表中的关联的主表的字段信息是表达式,需要通过表达式查到到报表列id
      report.children && report.children.forEach(child => {
        if (child.referenceReportColumnId) {
          child.referenceReportColumnId = report.columns.find(n => n.expressionText === child.referenceReportColumnId).id
        }
      })
      this.reports.find(n => n.id === tab.id).report = report
      if (report.columnEdit) {
        await this.$axios.get(`/form-api/defines/${report.editColumnForm}`).then(res => {
          this.formDefinition = res.data
        })
      }
    },
    goSearch () {
      this.$refs.reportTab[0].goSearch(this.formRuntimeDialog.title)
    },
    closeReportDialog () {
      this.$emit('closeReportDialog')
    }
  }
}
</script>
<style lang="scss">
.group-tabs.el-tabs--card {
  .el-tabs__nav-scroll {
    overflow-x: scroll;
    border-bottom: 1px solid transparent;
    position: relative;

    &::after {
      content: '';
      width: 100%;
      height: 1px;
      position: absolute;
      left: 0;
      top: 28px;
      background: #EBEBEB;
      display: block;
    }
  }

  .el-tabs__nav-prev,
  .el-tabs__nav-next {
    display: none;
  }
  >.el-tabs__header .el-tabs__nav {
    border-top: 1px solid transparent;
  }
  .el-tabs__header {
    margin: 0;
    border-bottom: 1px solid transparent;
  }

  .el-tabs__header .el-tabs__item {

    border-bottom: 1px solid #EBEBEB;
    border-top: 1px solid #EBEBEB;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .el-tabs__content{
    margin-top: -8px;
  }

  .el-tabs__item {
    color: #29282E;
    background: #F8F8F8;
    line-height: 28px;
    height: 28px;
    text-align: center;

    &.is-active,
    &:visited,
    &:focus {
      .tags-view-item {
        color: #fff;
      }

      color: #fff;
      background: var(--primary, #55ACF1);

      &:hover {
        .tags-view-item {
          color: #fff;
        }

        color: #fff;
        background:var(--primary, #55ACF1);
      }
    }

    &:hover {
      background: var(--light-9, #E9F2F9);
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/group-report-tabs.vue